export const comsP1Template = (
  node: HTMLElement,
) => `<one-paper background="legal-1" padding="sm">
${node.innerHTML}
</one-paper>`;

export const comsP2Template = (
  node: HTMLElement,
) => `<one-paper background="legal-2" padding="sm">
${node.innerHTML}
</one-paper>`;

export const comsP3Template = (
  node: HTMLElement,
) => `<one-paper background="legal-3" padding="sm">
${node.innerHTML}
</one-paper>`;
